/*
  Persistent hamburger menu, fixed top-right, above the snap-scroll
  container. Opens a minimal list - Shorts / Novels for now, content
  expands as more works are added.
*/

import { showWhoAreWeModal } from './WhoAreWeModal.js';

export function renderMenuIcon() {
  const wrapper = document.createElement('div');
  wrapper.className = 'fixed top-6 right-6 z-50';

  const btn = document.createElement('button');
  btn.className = 'menu-icon-btn';
  btn.textContent = '\u2630';
  btn.setAttribute('aria-label', 'Menu');

  const dropdown = document.createElement('div');
  dropdown.className = 'hidden absolute right-0 mt-2 w-52 menu-dropdown fade-in';

  const items = [
    { label: "Myth's Shorts", targetIndex: 0 },
    { label: "Myth's Novels", targetIndex: 1 },
    { label: 'Stygian Myth', targetIndex: 2 },
  ];

  items.forEach((item) => {
    const link = document.createElement('a');
    link.href = `#section-${item.targetIndex}`;
    link.className = 'menu-dropdown-item';
    link.textContent = item.label;
    link.addEventListener('click', () => dropdown.classList.add('hidden'));
    dropdown.appendChild(link);
  });

  // Who Are We - plain-language orientation modal, distinct from the
  // "Stygian Myth" About section entry above (that's the in-voice
  // mood piece; this is the functional explainer).
  const whoAreWeItem = document.createElement('button');
  whoAreWeItem.type = 'button';
  whoAreWeItem.className = 'menu-dropdown-item';
  whoAreWeItem.textContent = 'Who Are We';
  whoAreWeItem.addEventListener('click', () => {
    dropdown.classList.add('hidden');
    showWhoAreWeModal();
  });
  dropdown.appendChild(whoAreWeItem);

  btn.addEventListener('click', () => {
    dropdown.classList.toggle('hidden');
  });

  wrapper.append(btn, dropdown);
  return wrapper;
}
